var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelsRcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RCL-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9 4V15.561C25.588 16.0791 25.9948 16.8887 26 17.75V26H24.9V23.921H5.1V26H4V17.761C4.00172 16.8958 4.40889 16.0815 5.1 15.561V4H24.9ZM6.2 5.1V15H8.158C7.76617 14.3214 7.7649 13.4855 8.15467 12.8057C8.54443 12.1259 9.26639 11.7047 10.05 11.7H13.35C13.9836 11.7036 14.585 11.9802 15 12.459C15.415 11.9802 16.0164 11.7036 16.65 11.7H19.95C20.7336 11.7047 21.4556 12.1259 21.8453 12.8057C22.2351 13.4855 22.2338 14.3214 21.842 15H23.8V5.1H6.2ZM8.95 13.9C8.95 13.2925 9.44249 12.8 10.05 12.8H13.35C13.9575 12.8 14.45 13.2925 14.45 13.9C14.45 14.5075 13.9575 15 13.35 15H10.05C9.44249 15 8.95 14.5075 8.95 13.9ZM16.65 12.8C16.0425 12.8 15.55 13.2925 15.55 13.9C15.55 14.5075 16.0425 15 16.65 15H19.95C20.5575 15 21.05 14.5075 21.05 13.9C21.05 13.2925 20.5575 12.8 19.95 12.8H16.65ZM23.25 16.1C24.1613 16.1 24.9 16.8387 24.9 17.75V18.971H5.1V17.75C5.1 16.8387 5.83873 16.1 6.75 16.1H23.25ZM5.1 20.0703V22.8203H24.9V20.0703H5.1Z",
    fill: "#151617"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsRcl);
export default __webpack_public_path__ + "static/media/hotels-rcl.6d54e135bc043c38307c8407eb8a94c1.svg";
export { ForwardRef as ReactComponent };